import React from 'react';

import {PrimaryDataText, SecondaryDataText} from "../../Typography";
import {Box} from "@material-ui/core";

export default ({item, subItem, alignLeft}) => (
  <>
    <Box maxWidth="100%" width="fit-content" m={alignLeft ? '0' : '0 auto'}>
      <PrimaryDataText>
        {item}
      </PrimaryDataText>
    </Box>
    {subItem && (
      <Box maxWidth="100%" width="fit-content" m={alignLeft ? '.6rem 0 0' : '.6rem auto 0'}>
        <SecondaryDataText>
          {subItem}
        </SecondaryDataText>
      </Box>
    )}
  </>
)
